import { render, staticRenderFns } from "./tabForm.vue?vue&type=template&id=3c9d7ec1&scoped=true&"
import script from "./tabForm.vue?vue&type=script&lang=js&"
export * from "./tabForm.vue?vue&type=script&lang=js&"
import style0 from "./tabForm.vue?vue&type=style&index=0&id=3c9d7ec1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9d7ec1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c9d7ec1')) {
      api.createRecord('3c9d7ec1', component.options)
    } else {
      api.reload('3c9d7ec1', component.options)
    }
    module.hot.accept("./tabForm.vue?vue&type=template&id=3c9d7ec1&scoped=true&", function () {
      api.rerender('3c9d7ec1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/stayWarehousing/tabForm.vue"
export default component.exports